import { gql } from 'graphql-request'

export const watchLaterMutation = () => gql`
  mutation ($id: String!) {
    toggleWatchLater(id: $id) {
      success
      reason
    }
  }
`

